import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Configuration axios
const api = axios.create({
  baseURL: API,
  timeout: 10000,
});

// Services API
export const servicesAPI = {
  getAll: () => api.get('/services'),
  getById: (id) => api.get(`/services/${id}`),
};

// Gallery API
export const galleryAPI = {
  getAll: (service = null) => {
    const params = service ? { service } : {};
    return api.get('/gallery', { params });
  },
};

// Pricing API  
export const pricingAPI = {
  getAll: (category = null) => {
    const params = category ? { category } : {};
    return api.get('/pricing', { params });
  },
};

// Locations API
export const locationsAPI = {
  getAll: () => api.get('/locations'),
  getBookingLocations: () => api.get('/locations/booking'),
};

// Bookings API
export const bookingsAPI = {
  create: (bookingData) => api.post('/bookings', bookingData),
  getAll: () => api.get('/bookings'),
  getAvailability: (date, duration) => api.get('/availability', { params: { date, duration } }),
};

// Contacts API
export const contactsAPI = {
  create: (contactData) => api.post('/contacts', contactData),
  getAll: () => api.get('/contacts'),
};

// Health check
export const healthAPI = {
  check: () => api.get('/health'),
};

export default api;